var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.computedDivClass},[_c('v-file-input',_vm._b({class:_vm.computedClass,attrs:{"outlined":"","show-size":"","prepend-icon":"","append-icon":"bx bx-paperclip","accept":_vm.accept,"label":_vm.label,"error-messages":_vm.errorMessage},on:{"change":_vm.onFileChange}},'v-file-input',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }